export var CustomerActionTypes;
(function (CustomerActionTypes) {
    CustomerActionTypes["INITIAL_STATE"] = "INITIAL_STATE";
    CustomerActionTypes["CUSTOMER_LOGIN_ANONYMOUS"] = "CUSTOMER_LOGIN_ANONYMOUS";
    CustomerActionTypes["CUSTOMER_LOGIN"] = "CUSTOMER_LOGIN";
    CustomerActionTypes["CUSTOMER_BOOKMARK_ACTION"] = "CUSTOMER_BOOKMARK_ACTION";
})(CustomerActionTypes || (CustomerActionTypes = {}));
